import { TariffViewModel } from '@common/model/billing/tariff/view';
import { secondsInMonth } from 'date-fns';
import { parse, toSeconds } from 'iso8601-duration';

/**
 * Возвращает true если период оплаты тарифа содержит хотя бы 1 месяц.
 * Позволяет отличить тарифы с периодом оплаты меньше месяца
 * @param tariff
 */
export const isContainMonth = (tariff: Pick<TariffViewModel, 'period'>) => secondsInMonth <= toSeconds(parse(tariff.period || 'PT1S'));
